module.exports = __webpack_public_path__ + "static/media/06.d3fb6b2b.jpg";